import { useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import HelmetMetaData from "@/components/HelmetMetaData";
import { useTheme } from "@/hooks/useTheme";
import Ios from "./Ios";
import Android from "./Andriod";

const PwaTutorial = () => {
  const [isIOS, setIsIOS] = useState(false);
  const navigate = useNavigate();

  const { setTheme } = useTheme();

  useLayoutEffect(() => {
    setTheme("light");
    const isPWA = false;
    if (isPWA) {
      navigate("/");
    }
  }, []);

  return (
    <>
      <HelmetMetaData
        title="Billzpay PWA Tutorial"
        description="Learn how to install Billzpay as a Progressive Web App for an enhanced experience on iOS and Android devices."
      />

      <div className="font-rubik mx-auto h-full max-w-7xl p-4 py-7 md:p-[26px]">
        <p className="font-geist text-primary text-[12px] font-semibold uppercase lg:text-base">
          Access Billzpay with Ease
        </p>

        <h1 className="font-geist text-[24px] leading-[1.1] font-bold text-black/75 md:text-[28.8px] md:leading-[1.2] lg:text-[44px]">
          Elevate Your Billzpay Experience with a PWA
        </h1>

        <p className="font-geist max-w-2xl text-sm font-light text-gray-500 lg:text-base">
          Upgrade your interaction with the Billzpay website by installing it as
          a Progressive Web App. This guide will show you how to get started
          effortlessly
        </p>

        <div className="flex flex-col items-center rounded-lg p-4">
          <h3 className="mb-2 text-lg font-medium">Device Type</h3>

          <div className="flex space-x-2">
            <button
              className={`rounded-full border-none px-4 py-2 outline-none ${
                !isIOS ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-700"
              }`}
              onClick={() => setIsIOS(false)}
            >
              iOS
            </button>

            <button
              className={`rounded-full border-none px-4 py-2 outline-none ${
                isIOS ? "bg-green-500 text-white" : "bg-gray-200 text-gray-700"
              }`}
              onClick={() => setIsIOS(true)}
            >
              Android
            </button>
          </div>
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={isIOS ? "android" : "ios"}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            {isIOS ? <Android /> : <Ios />}
          </motion.div>
        </AnimatePresence>
      </div>
    </>
  );
};

export default PwaTutorial;
